import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast, SuccessToast } from 'services/toasterService';

export default function useAddOrganisation(closeModal) {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.REGISTER_ADMIN,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        closeModal();
        SuccessToast({ text: data?.message });
        queryClient.invalidateQueries('get-organisation-data');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
